import React from "react";

import ApprovalTable from "./ApprovalTable";
import { useResponseApprovalInfoRequestContext } from "@context/ResponseApprovalInfoRequestContext";
import { useSearchParams } from "react-router-dom";
import StepActions from "@components/zenith/ui/StepActions";

type SelectApprovalProps = {
  onSubmit: () => void;
  onCancel: () => void;
};

const SelectApproval: React.FunctionComponent<SelectApprovalProps> = ({
  onSubmit,
  onCancel,
}) => {
  const { approval, setApproval } = useResponseApprovalInfoRequestContext();
  const [searchParams] = useSearchParams();
  const approvalId = searchParams.get("selectedId") ?? "";

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form className="flex flex-col grow" onSubmit={handleSubmit}>
      <ApprovalTable
        onSelect={(value: any) => setApproval(value)}
        selected={approval}
        filterId={approvalId}
      />

      <StepActions onCancel={onCancel} nextDisabled={!approval} />
    </form>
  );
};

export default SelectApproval;
